(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./expressionOfGratitudeAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./expressionOfGratitudeAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.expressionOfGratitudeAssertions, global.schema);
    global.expressionOfGratitudeNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _expressionOfGratitudeAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateExpressionOfGratitude = hydrateExpressionOfGratitude;
  _exports.hydrateExpressionOfGratitudes = hydrateExpressionOfGratitudes;
  _exports.normalizeExpressionOfGratitude = normalizeExpressionOfGratitude;
  _exports.normalizeExpressionOfGratitudes = normalizeExpressionOfGratitudes;

  /**
   * Normalize an ExpressionOfGratitude
   * @param   {ExpressionOfGratitude} expressionOfGratitude - expressionOfGratitude to normalize
   * @returns {number} data.result - Id of the expressionOfGratitude
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeExpressionOfGratitude(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    return (0, _normalizr.normalize)(expressionOfGratitude, _schema.expressionOfGratitudeSchema);
  }

  /**
   * Normalize ExpressionOfGratitudes
   * @param   {Array<ExpressionOfGratitude>} expressionOfGratitudes - expressionOfGratitudes to normalize
   * @returns {Array<number>} data.result - Ids of the expressionOfGratitudes
   * @returns {NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeExpressionOfGratitudes(expressionOfGratitudes) {
    (0, _assert.assertArray)(expressionOfGratitudes, "expressionOfGratitudes");
    return (0, _normalizr.normalize)(expressionOfGratitudes, _schema.expressionOfGratitudesShema);
  }

  /**
   * Denormalize an ExpressionOfGratitude
   * @param   {number} id - Id of the expressionOfGratitude
   * @param   {Entities} entities - Normalized data entities
   * @returns {ExpressionOfGratitude} Denormalized expressionOfGratitude
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateExpressionOfGratitude(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.expressionOfGratitudeSchema, entities);
  }

  /**
   * Denormalize ExpressionOfGratitudes
   * @param   {Array<number>} ids - Ids of the expressionOfGratitudes
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<ExpressionOfGratitude>} Denormalized expressionOfGratitudes
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateExpressionOfGratitudes(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.expressionOfGratitudesShema, entities);
  }
});